import { Component, OnInit, Input, ViewChild } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { Router } from '@angular/router';

import { LoginService } from '../../../login/login.service';
import { SwitchboardService } from '../../../switchboard/switchboard.service';

import { SwitchboardObject } from '../../../switchboard/switchboard_object';

@Component({
    selector: 'app-portal-queue-edit',
    templateUrl: './portal-queue-edit.component.html',
    styleUrls: ['./portal-queue-edit.component.css']
})
export class PortalQueueEditComponent implements OnInit {

    account_id;
    parent;

    uuid: string;
    switchboard_object: SwitchboardObject;

    constructor(
        private route: ActivatedRoute,
        private authService: LoginService,
        private switchboardService: SwitchboardService
    ) { }

    ngOnInit() {
        this.uuid = this.route.snapshot.paramMap.get('uuid');
        this.getSwitchboardObject();
        this.authService.getCurrentAccount()
        .subscribe(account => {
            this.account_id = account.id;
            this.getParent();
        });
    }

    getParent() {
        const parent_uuid = this.route.snapshot.queryParamMap.get('parent');
        if (parent_uuid) {
            this.switchboardService.getSwitchboardObject(parent_uuid)
                .subscribe(parent => this.parent = parent);
        }
    }

    backToParent() {
        window.history.go(-2);
    }

    getSwitchboardObject() {
        this.switchboardService.getSwitchboardObject(this.uuid)
            .subscribe((object: SwitchboardObject) => this.switchboard_object = object);
    }

}
